import { render, staticRenderFns } from "./CampaignSectionSetting.vue?vue&type=template&id=cfadcb48&scoped=true&"
import script from "./CampaignSectionSetting.vue?vue&type=script&lang=ts&"
export * from "./CampaignSectionSetting.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSectionSetting.vue?vue&type=style&index=0&id=cfadcb48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfadcb48",
  null
  
)

export default component.exports